import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import pt from '@/shared/locales/pt.json';
import ptPT from '@/shared/locales/pt-PT.json';
import en from '@/shared/locales/en.json';
import es from '@/shared/locales/es.json';
import fr from '@/shared/locales/fr.json';
import ru from '@/shared/locales/ru.json';
import zh from '@/shared/locales/zh.json';
import ja from '@/shared/locales/ja.json';

const resources = {
  'pt-BR': {
    translation: pt,
  },
  'pt-PT': {
    translation: ptPT,
  },
  'en-US': {
    translation: en,
  },
  'es-ES': {
    translation: es,
  },
  'fr-FR': {
    translation: fr,
  },
  'ru-RU': {
    translation: ru,
  },
  'zh-CN': {
    translation: zh,
  },
  'ja-JP': {
    translation: ja,
  },
};

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    debug: false,

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
